import { defineComponent as o, createBlock as i, openBlock as l, resolveDynamicComponent as a, normalizeStyle as n, normalizeClass as s, unref as e, withCtx as d, renderSlot as p } from "vue";
import m from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/layouts/Gallery/gallery.js";
import { l_gallery_GridTemplateColumns_min as h } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/l_gallery_GridTemplateColumns_min.js";
import { l_gallery_GridTemplateColumns_max as f } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/l_gallery_GridTemplateColumns_max.js";
import { cssVarsFromBreakpointProps as r } from "../../breakpoints.js";
const C = /* @__PURE__ */ o({
  name: "PfGallery",
  __name: "Gallery",
  props: {
    component: { default: "div" },
    gutter: { type: Boolean },
    minWidth: {},
    minWidthSm: {},
    minWidthMd: {},
    minWidthLg: {},
    minWidthXl: {},
    minWidth2xl: {},
    maxWidth: {},
    maxWidthSm: {},
    maxWidthMd: {},
    maxWidthLg: {},
    maxWidthXl: {},
    maxWidth2xl: {}
  },
  setup(W) {
    return (t, u) => (l(), i(a(t.component), {
      class: s([e(m).gallery, { [e(m).modifiers.gutter]: t.gutter }]),
      style: n({
        ...e(r)(t.$props, "minWidth", e(h).name),
        ...e(r)(t.$props, "maxWidth", e(f).name)
      })
    }, {
      default: d(() => [
        p(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "style"]));
  }
});
export {
  C as default
};
